import React, { useEffect, useState} from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCartItems, selectCartTotal } from './../../redux/Cart/cart.selectors';
import { createStructuredSelector } from 'reselect';
import Button from './../forms/Button';
import Item from './Item';

const mapState = createStructuredSelector({
	cartItems: selectCartItems,
	total: selectCartTotal
});

const Checkout = () => {
	const history = useHistory();
	const { cartItems, total } = useSelector(mapState);
	const [check, setCheck] = useState(true)

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	function accept(){
		setCheck(!check)
	}


	const plansArray = []
	if(Array.isArray(cartItems)){
		for(let i = 0; i < cartItems.length; i++){
			if(cartItems[i].productCategory === "plans"){
			plansArray.push(cartItems[i]);
			}
		}
	}


	const errMsg = 'You currently have no items in your cart!';
	return(
		<div className="checkout py-5 container">
			<h1>
			Checkout
			</h1>

			<div className="cart">
				{cartItems.length > 0 ? (
				<table border="0" cellPadding="0" cellSpacing="0">
					<tbody>
					<tr>
						<td>
						<table className="checkoutHeader" border="0" cellPadding="10" cellSpacing="0">
							<tbody>
							<tr>
								<th>
								Product Category
								</th>
								<th>
								Product
								</th>
								<th className="text-center">
								Price
								</th>
								<th className="text-center">
								Remove
								</th>
							</tr>
							</tbody>
						</table>
						</td>
					</tr>
					<tr>
						<td>
						<table border="0" cellSpacing="0" cellPadding="0">
							<tbody>
							{cartItems.map((item, pos) => {
								return (
								<tr key={pos}>
									<td>
										<Item {...item} />
									</td>
								</tr>
								);
							})}
							</tbody>
						</table>
						</td>
					</tr>
					<tr>
						<td>
						<table border="0" cellSpacing="0" cellPadding="0">
							<tbody>
							<tr>
								<td>
								<table border="0" cellPadding="10" cellSpacing="0">
									<tbody>
									<tr>
										<td>
										<h3>
										Total: ${total}
										</h3>
										</td>
									</tr>
									</tbody>
								</table>
								</td>
							</tr>
							<tr>
								<td>
								<table border="0" cellPadding="10" cellSpacing="0">
									<tbody>
									<tr className="row">
										{/* <td className="col text-center">
										<Button className="serviceBtn btn" onClick={() => history.goBack()}>
											MORE SERVICES
										</Button>
										</td> */}
										<td className=" col text-right">
										<Button className="serviceBtn btn" onClick={() => history.push('/payment')} disabled={check}>
											PAYMENT
										</Button>
										</td>
									</tr>
									<tr className="row ">
										<td className="col d-flex mx-auto justify-content-end">
										<div className="checkBox mr-2" onClick={accept}>
											{!check &&(
												<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 check" fill="none" viewBox="0 0 24 24" stroke="currentColor">
												<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
												</svg>
											)}
										</div>
										<p>I accept the</p> 
										<Link to="/termsAndConditions" className="t_C ml-1">
											Terms and Conditions
										</Link>
										</td>
									</tr>
									</tbody>
								</table>
								</td>
							</tr>
							</tbody>
						</table>
						</td>
					</tr>
					</tbody>
				</table>
				) : (
					<p>
					 {errMsg} <br></br>
					 {/* <Button className="serviceBtn btn mt-3" onClick={() => history.goBack()}>
							Continue Shopping
					</Button> */}
					</p>
				)}
			</div>
		</div>
	);
};

export default Checkout;
